import { signupCookie } from '@/utils/cookies/signupCookie';
import gtm from '@/utils/gtm';
import EfBundlesCalculator from '@elem/ui/ef-bundles-calculator';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import classNames from 'classnames';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { BaseCardBtnText } from 'lowcode/common/LangText/BaseCardBtnText';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useRef, useState, useMemo } from 'react';
import CornerMarkIntegral from './comps/CornerMarkIntegral';
import MarkDiscount from './comps/MarkDiscount';
import PriceBox from './comps/PriceBox';
import './index.scss';
const getValueFromScale = (price: number, scaleNum1: number, scaleNum2 = 100) => {
    const price2 = (price * scaleNum1) / scaleNum2;
    return Number(`${price2.toFixed(2)}`);
};
export default function CardItem({ item = {}, cardType, cardBgColor, isEditStatus }: any) {
    const { locale = 'us' } = useRouter();
    console.log({ item });
    const imgPc = item.imgType === 'shopify' ? item.shopifyPc : item.pc;
    const title = item.titleType === 'shopify' ? item.shopifyTitle : item.title;
    const inventoryPolicy = item.inventoryPolicy; // 库存方式
    const subTitle1 = item.subTitle1;
    const subTitle2 = item.subTitle2;
    const btnTypes = item.btnTypes || [];
    console.log({ btnTypes });
    // const btnTypes = ['BuyNow'];
    const hasLearnMore = btnTypes.includes('LearnMore');
    const hasBuyNow = btnTypes.includes('BuyNow');
    const hasAddToCart = btnTypes.includes('AddToCart');
    const hasLearnCart = btnTypes.includes('LearnMore-cart');
    const hasBuyCart = btnTypes.includes('BuyNow-cart');
    const LearnMoreHrefA = item.shopifyHandle ? `https://${locale}.ecoflow.com/products/${item.shopifyHandle}` : undefined;
    const LearnMoreBtnInputValue = item.LearnMoreBtnInputValue;
    const LearnMoreHrefB = item.LearnMoreBtnInputFlag && LearnMoreBtnInputValue ? LearnMoreBtnInputValue : LearnMoreHrefA;
    const [LearnMoreHref2, setLearnMoreHref2] = useState(LearnMoreHrefB);
    const BuyNowHrefVal = item.variantId ? `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button` : '';
    const [BuyNowHref2, setBuyNowHref2] = useState(BuyNowHrefVal);
    // 售价 start
    const shopifyPricePrice = item.shopifyPricePrice;
    const shopifyPriceCompareAtPrice = item.shopifyPriceCompareAtPrice;
    const priceNormal1 = item.priceType === 'shopify' ? (item.priceShopify === 'Price' ? shopifyPricePrice : shopifyPriceCompareAtPrice) : item.priceManual; //售价
    const priceNormal2 = Number(`${priceNormal1}`);
    const [priceNormal, setPriceNormal] = useState(priceNormal2);
    // 售价 end
    // 划线价 start
    const shopifyCompareAtPricePrice = item.shopifyCompareAtPricePrice;
    const shopifyCompareAtPriceCompareAtPrice = item.shopifyCompareAtPriceCompareAtPrice;
    const priceCompareAt1 =
        item.compareAtPriceType === 'shopify'
            ? item.compareAtPriceShopify === 'Price'
                ? shopifyCompareAtPricePrice
                : shopifyCompareAtPriceCompareAtPrice
            : item.compareAtPriceManual; //划线价
    const priceCompareAt2 = Number(`${priceCompareAt1}`);
    const [priceCompareAt, setPriceCompareAt] = useState(priceCompareAt2);
    // 划线价 end
    // 会员价 start
    const shopifyMemberPrice = item.shopifyMemberPrice;
    const shopifyMemberCompareAtPrice = item.shopifyMemberCompareAtPrice;
    const priceMember1 =
        item.memberPriceType === 'shopify' ? (item.memberPriceShopify === 'Price' ? shopifyMemberPrice : shopifyMemberCompareAtPrice) : item.memberPriceManual; //会员价
    const priceMember2 = Number(`${priceMember1}`);
    const [priceMember, setPriceMember] = useState(priceMember2);
    // 会员价 end
    const maxCanBuyCount = Number(`${item.maxCanBuyCount}`); //最多能购买

    const priceMax = priceCompareAt || priceNormal || priceMember; //最高价
    const priceMin = priceMember || priceNormal || priceCompareAt; //最低价
    const priceKey = `${priceMember2}${priceCompareAt2}${priceNormal2}`;
    // 链接按钮
    const toShopifyLinks = item.toShopifyLinks || [];
    const titleImgLink = item.titleImgLink || undefined;
    const titleHasLink = titleImgLink && toShopifyLinks.includes('title'); // 标题是否有链接
    const imgHasLink = titleImgLink && toShopifyLinks.includes('img'); // 图片是否有链接
    const memberDiscountList2 = (item.memberDiscountList || []).filter((item: any) => {
        return item.discountRatio && item.fullReduction;
    }); //折扣列表
    const isShowLMarkerHTitle1 = item.discountPositionType === 'LMarkerHTitle'; //是否显示标题上的积分倍数--使用了设置
    const isShowLMarkerHTitle2 = item.integralCornerMarkerType === 'IntegralCornerMarkerFixed'; //没有使用设置,但是,选的是固定文案
    const isShowLMarkerHTitle = isShowLMarkerHTitle1 || isShowLMarkerHTitle2; //是否显示标题上的积分倍数
    const inventory = inventoryPolicy === 'deny' ? item.inventory || 0 : 999999; //库存
    const isSoldOut = inventory <= 0;
    const TextA = BaseCardBtnText[locale] || BaseCardBtnText['us'];
    const [buyNum, setBuyNum] = useState(1);
    const BuyNowCartLink = useMemo(() => {
        if (buyNum && buyNum >= 1) {
            return `https://ecoflow-tech.myshopify.com/cart/40758830071881;${buyNum}?channel=buy_button`;
        }
        return 'https://ecoflow-tech.myshopify.com/cart/40758830071881;1?channel=buy_button';
    }, [buyNum]);

    const styleItem: any = {
        '--member-cardBgColor': cardBgColor,
        '--member-titleColor': item.titleColor,
        '--member-subTitle1Color': item.subTitle1Color,
        '--member-subTitle2Color': item.subTitle2Color,
        '--member-discountLabelColor': item.discountLabelColor,
        '--member-discountLabelBg': item.discountLabelBg,

        '--member-priceColor': item.priceColor,
        '--member-compareAtPriceColor': item.compareAtPriceColor,
        '--member-memberPriceColor': item.memberPriceColor,

        '--member-memberCornerMarkerColor': item.memberCornerMarkerColor,
        '--member-memberCornerMarkerBg': item.memberCornerMarkerBg,

        '--member-LearnMoreColorFont': item.LearnMoreColorFont,
        '--member-LearnMoreColorBorder': item.LearnMoreColorBorder,

        '--member-BuyNowColorFont': item.BuyNowColorFont,
        '--member-BuyNowColorBorder': item.BuyNowColorBorder,

        '--member-AddToCartColorFont': item.AddToCartColorFont,
        '--member-AddToCartColorBorder': item.AddToCartColorBorder,

        '--member-LearnMoreCartColorFont': item.LearnMoreCartColorFont,
        '--member-LearnMoreCartColorBorder': item.LearnMoreCartColorBorder,

        '--member-cardBtnColorText': item.cardBtnColorText,
        '--member-cardBtnColorBg': item.cardBtnColorBg,

        '--member-IntegralCornerMarkerFixedTextColor': item.IntegralCornerMarkerFixedTextColor,
        '--member-IntegralCornerMarkerFixedTextBg': item.IntegralCornerMarkerFixedTextBg,
    };
    const cartCount = useRef(1); //当前购买量
    useEffect(() => {
        // const isLogin = getIsLogin();
        // const pathname = location.href;
        // const toLoginUrl1 = `/${locale}/login?redirect=${pathname}`; // 前往登录的地址
        // if (hasLearnMore && LearnMoreHref2 && item.LearnMoreNeedLogin === 'Y' && !isLogin) {
        //     setLearnMoreHref2(toLoginUrl1);
        // }
        // if (hasBuyNow && BuyNowHref2 && item.BuyNowNeedLogin === 'Y' && !isLogin) {
        //     setBuyNowHref2(toLoginUrl1);
        // }
    }, []);
    useEffect(() => {
        //setLearnMoreHref2(LearnMoreHrefB);
        //setBuyNowHref2(BuyNowHrefVal);
        setPriceNormal(priceNormal2);
        setPriceCompareAt(priceCompareAt2);
        setPriceMember(priceMember2);
        // 登录态
        const isLogin = getIsLogin();
        const pathname = location.href;
        const toLoginUrl1 = `/${locale}/login?redirect=${pathname}`; // 前往登录的地址

        if (hasLearnMore && LearnMoreHref2 && item.LearnMoreNeedLogin === 'Y' && !isLogin) {
            setLearnMoreHref2(toLoginUrl1);
        } else {
            setLearnMoreHref2(LearnMoreHrefB);
        }
        if (hasBuyNow && BuyNowHref2 && item.BuyNowNeedLogin === 'Y' && !isLogin) {
            setBuyNowHref2(toLoginUrl1);
        } else {
            setBuyNowHref2(BuyNowHrefVal);
        }
    }, [isEditStatus, priceNormal2, priceCompareAt2, priceMember2, LearnMoreHrefB, BuyNowHrefVal]);

    // 进行折扣价格
    const discountListPriceHandle = (itemCount: number) => {
        const len = memberDiscountList2.length;
        if (len === 0) {
            return;
        }
        let discountNum = 0; //折扣多少
        for (let i = len - 1; i >= 0; i--) {
            const itemA = memberDiscountList2[i] || {};
            const fullReduction = Number(`${itemA.fullReduction}`); //件
            const discountRatio = Number(`${itemA.discountRatio}`); //折扣比例
            // 必须2个同时设了值才行
            if (!fullReduction || !discountRatio) {
                continue;
            }
            if (itemCount >= fullReduction) {
                discountNum = discountRatio; //从最大的开始遍历,得到值
                break;
            }
        }
        if (!discountNum) {
            // 恢复原价
            setPriceMember(priceMember2);
            setPriceNormal(priceNormal2);
            setPriceCompareAt(priceCompareAt2);
            return false;
        }
        const scaleVal = 100 - discountNum; //执行的比例
        if (priceMember2) {
            const priceMemberA = getValueFromScale(priceMember2, scaleVal, 100);
            setPriceMember(priceMemberA);
        }
        if (priceNormal2) {
            const priceNormalA = getValueFromScale(priceNormal2, scaleVal, 100);
            setPriceNormal(priceNormalA);
        }
        if (priceCompareAt2) {
            const priceCompareAtA = getValueFromScale(priceCompareAt2, scaleVal, 100);
            setPriceCompareAt(priceCompareAtA);
        }
    };
    // 购物车数量回调
    const calculatorCallback = (value: number, item: any) => {
        if (isSoldOut) {
            return;
        }

        cartCount.current = Number(`${value}`);
        discountListPriceHandle(cartCount.current);
    };
    // 添加到购物车
    const addToCartHandle = () => {
        if (isSoldOut) {
            return;
        }
        const item2 = {
            ...item,
            img: imgPc,
            name: title,
            discountPrice: priceMin,
            inventoryQuantity: item.inventory,
            maxCanBuyCount: maxCanBuyCount,
        };
        let quantity = cartCount.current;
        if (quantity > maxCanBuyCount) {
            quantity = maxCanBuyCount;
        }

        // editorEventsBus.emit('efshopingcart-add', [
        //     {
        //         item: item2,
        //         quantity: quantity,
        //     },
        // ]);
        EcoDesignEventsBus.emit('eco-cart-add', [
            {
                item: item2,
                quantity: quantity,
            },
        ]);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: 'none',
                product_name: title,
                price: priceMin,
                tag: 'none',
                quantity: quantity,
                button_name: TextA.AddToCart,
            });
        } catch (error) {}
    };
    // 文案
    const LearnMoreText = TextA.LearnMore;
    const BuyNowText = TextA.BuyNow;
    // 埋点-LearnMore
    const LearnMoreGtm = {
        event: 'uaEvent',
        event_name: 'buy',
        product_name: title,
        position: 'member',
    };
    // 埋点-BuyNow
    const BuyNowGtm = {
        event: 'uaEvent',
        event_name: 'checkout',
        button_name: `${BuyNowText}_${title}`,
    };
    // 埋点-LearnCart
    const LearnCartGtm = {
        event: 'uaEvent',
        event_name: 'buy',
        product_name: title,
        position: 'member',
    };

    const classNameItem = classNames('member-product-scene-item', {
        [`member-product-scene-item-type-${cardType}`]: cardType,
        [`member-product-scene-item-position-${item.cardPosition}`]: item.cardPosition,
        [`member-product-scene-item-position-discount-${item.discountPositionType}`]: item.discountPositionType,
        [`member-product-scene-item-AddToCartBtnType-${item.AddToCartBtnType}`]: item.AddToCartBtnType,
    });

    const classNameBtnBox = classNames('member-product-scene-item-btn-box', {
        [`member-product-scene-item-btn-box-AddToCartBtnType-${item.AddToCartBtnType}`]: item.AddToCartBtnType,
    });

    return (
        <div className={classNameItem} style={styleItem}>
            <EfLink className="member-product-scene-item-img" href={imgHasLink ? titleImgLink : undefined}>
                {imgPc && <EfImg pc={imgPc} />}
            </EfLink>
            <div className="member-product-scene-item-msg">
                <div className="member-product-scene-item-msg-in">
                    <div className="member-product-scene-item-corner-mark">
                        <MarkDiscount item={item} priceMax={priceMax} priceMin={priceMin} TextA={TextA} locale={locale} />
                        {!isShowLMarkerHTitle2 && (
                            <CornerMarkIntegral priceMember={priceMember} priceNormal={priceNormal} priceCompareAt={priceCompareAt} item={item} TextA={TextA} />
                        )}
                        {isShowLMarkerHTitle2 && item.IntegralCornerMarkerFixedText && (
                            <div className="member-product-scene-item-credits-scale3 member-product-scene-item-corner-mark-right">
                                {item.IntegralCornerMarkerFixedText}
                            </div>
                        )}
                    </div>

                    <EfLink className="member-product-scene-item-title" href={titleHasLink ? titleImgLink : undefined}>
                        {title}
                    </EfLink>
                    <div className="member-product-scene-item-subTitle1">{subTitle1}</div>
                    <div className="member-product-scene-item-subTitle2">{subTitle2}</div>

                    <Fragment key={priceKey}>
                        <PriceBox
                            item={item}
                            priceMember={priceMember}
                            priceNormal={priceNormal}
                            priceCompareAt={priceCompareAt}
                            locale={locale}
                            TextA={TextA}
                        />
                    </Fragment>

                    <div className="member-product-scene-item-discount-list">
                        {memberDiscountList2.map((item: any, index: number) => {
                            return (
                                <Fragment key={index}>
                                    <div
                                        className={`member-product-scene-item-discount-list-border member-product-scene-item-discount-list-border-${index}`}
                                    ></div>
                                    <div className="member-product-scene-item-discount-list-item">
                                        <div className="member-product-scene-item-discount-list-line1">
                                            <span className="member-product-scene-item-discount-list-line1-ms1">
                                                {item.discountRatio}
                                                {locale === 'de' && <>&nbsp;</>}%
                                            </span>
                                            {['eu', 'uk'].includes(locale) && <>&nbsp;</>}
                                            <span className="member-product-scene-item-discount-list-line1-ms2">
                                                {locale === 'de' && <>&nbsp;</>}
                                                {TextA.OFF}
                                            </span>
                                        </div>
                                        {['us', 'ca'].includes(locale) && item.rangeNum ? (
                                            <div className="member-product-scene-item-discount-list-line2">{item.rangeNum}</div>
                                        ) : (
                                            <div className="member-product-scene-item-discount-list-line2">
                                                {item.fullReduction}
                                                {['de', 'fr', 'eu', 'uk'].includes(locale) && <>&nbsp;</>}
                                                {item.fullReduction === '1' ? TextA.pc : TextA.pcs}
                                            </div>
                                        )}
                                    </div>
                                </Fragment>
                            );
                        })}
                    </div>
                    <div className={classNameBtnBox}>
                        {hasLearnMore && (
                            <EfLink
                                href={LearnMoreHref2}
                                className={`member-product-scene-item-btn member-product-scene-item-btn-LearnMore member-product-scene-item-btn-LearnMore-type-${
                                    item.LearnMoreBtnType || 'btnHover'
                                }`}
                                dataLayer={LearnMoreGtm}
                                onClick={() => {
                                    if (LearnMoreHref2?.includes?.('/login?')) {
                                        signupCookie?.({
                                            sector_name: title,
                                            entry_position: 0,
                                        });
                                    }
                                }}
                            >
                                {LearnMoreText}
                            </EfLink>
                        )}
                        {hasBuyNow && BuyNowHref2 && (
                            <EfLink
                                href={BuyNowHref2}
                                className={`member-product-scene-item-btn member-product-scene-item-btn-BuyNow${
                                    isSoldOut ? ' member-product-scene-item-btn-disabled' : ''
                                } member-product-scene-item-btn-BuyNow-type-${item.BuyNowBtnType || 'btnFill'}`}
                                dataLayer={BuyNowGtm}
                                onClick={() => {
                                    if (BuyNowHref2?.includes?.('/login?')) {
                                        signupCookie?.({
                                            sector_name: title,
                                            entry_position: 0,
                                        });
                                    }
                                }}
                            >
                                {isSoldOut ? TextA.SoldOut : BuyNowText}
                            </EfLink>
                        )}
                        {hasAddToCart && (
                            <div className={`member-product-scene-item-AddToCart-box${isSoldOut ? ' member-product-scene-item-AddToCart-box-disabled' : ''}`}>
                                <button className="member-product-scene-item-btn member-product-scene-item-btn-AddToCart" onClick={addToCartHandle}>
                                    {isSoldOut ? TextA.SoldOut : TextA.AddToCart}
                                </button>
                            </div>
                        )}
                        {!['us', 'ca'].includes(locale) ? (
                            <>
                                {hasLearnCart && (
                                    <div className={`member-product-scene-item-LearnCart-box`}>
                                        <EfBundlesCalculator
                                            defaultQuantity={1}
                                            item={{
                                                maxCanBuyCount: item.maxCanBuyCount,
                                                inventoryQuantity: item.maxCanBuyCount || inventory,
                                            }}
                                            callback={calculatorCallback}
                                        />
                                        <EfLink
                                            href={LearnMoreHref2}
                                            className="member-product-scene-item-btn member-product-scene-item-btn-LearnCart"
                                            dataLayer={LearnCartGtm}
                                            onClick={() => {
                                                if (BuyNowHref2?.includes?.('/login?')) {
                                                    signupCookie?.({
                                                        sector_name: LearnMoreText,
                                                        entry_position: 0,
                                                    });
                                                }
                                            }}
                                        >
                                            {LearnMoreText}
                                        </EfLink>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                {item.cardBtnType === 'learnmore' && (
                                    <div className={`member-product-scene-item-LearnCart-box`}>
                                        <EfBundlesCalculator
                                            defaultQuantity={1}
                                            item={{
                                                maxCanBuyCount: item.maxCanBuyCount,
                                                inventoryQuantity: item.maxCanBuyCount || inventory,
                                            }}
                                            callback={calculatorCallback}
                                        />
                                        <EfLink
                                            href={LearnMoreHref2}
                                            className="member-product-scene-item-btn member-product-scene-item-btn-LearnCart"
                                            dataLayer={LearnCartGtm}
                                            onClick={() => {
                                                if (BuyNowHref2?.includes?.('/login?')) {
                                                    signupCookie?.({
                                                        sector_name: LearnMoreText,
                                                        entry_position: 0,
                                                    });
                                                }
                                            }}
                                        >
                                            {LearnMoreText}
                                        </EfLink>
                                    </div>
                                )}
                                {item.cardBtnType === 'buy' && (
                                    <div className={`member-product-scene-item-LearnCart-box`}>
                                        <EfBundlesCalculator
                                            defaultQuantity={1}
                                            item={{
                                                maxCanBuyCount: item.maxCanBuyCount,
                                                inventoryQuantity: item.maxCanBuyCount || inventory,
                                            }}
                                            callback={(value: any, item: any) => {
                                                calculatorCallback(value, item);
                                                setBuyNum(value);
                                            }}
                                        />
                                        <EfLink
                                            href={BuyNowCartLink}
                                            className={`member-product-scene-item-btn member-product-scene-item-btn-BuyNowCard${
                                                isSoldOut ? ' member-product-scene-item-btn-disabled' : ''
                                            } member-product-scene-item-btn-BuyNow-type-${item.BuyNowBtnType || 'btnFill'} ${
                                                item.cardBtnShape !== 'fill' ? ' member-product-scene-item-btn-BuyNow-type-hollow' : ''
                                            }`}
                                            dataLayer={BuyNowGtm}
                                        >
                                            {isSoldOut ? TextA.SoldOut : BuyNowText}
                                        </EfLink>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
